/**
 * @typedef {import('./AdditionalFieldSelectConfiguration').AdditionalFieldSelectConfiguration} AdditionalFieldSelectConfiguration
 */

import Select from 'react-select';

/**
 * @typedef {Object} AdditionalFieldSelectPreviewProps
 * @property {AdditionalFieldSelectConfiguration} configuration
 */

/**
 * @param {AdditionalFieldSelectPreviewProps} props
 * @returns {JSX.Element}
 */
export function AdditionalFieldSelectPreview({ configuration }) {
  return (
    <div className='select2-container'>
      <Select
        classNamePrefix="select2-selection"
        className="select2-selection"
        options={configuration.options}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.value}
        isMulti={configuration.isMulti}
      />
    </div>
  )
}
